module.exports = __webpack_public_path__ + "static/media/back.ff12d91d.svg";